module.exports = __webpack_public_path__ + "img/Damilola Alex-Aina_ Data Analyst.ad60ec85.jpg";